module.exports = __webpack_public_path__ + "img/finance-home-icon.f3ce0451.svg";